import { render, staticRenderFns } from "./TripDetailStats.vue?vue&type=template&id=c4467346&scoped=true&"
import script from "./TripDetailStats.vue?vue&type=script&lang=ts&"
export * from "./TripDetailStats.vue?vue&type=script&lang=ts&"
import style0 from "./TripDetailStats.vue?vue&type=style&index=0&id=c4467346&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4467346",
  null
  
)

export default component.exports